<section class="buyer-sign-section" [ngClass]="mobileOrTablet ? 'mobile-or-tablet' : ''">
    <pdf-view
        [dealId]="dealId"
        [docId]="docId"
        [document]="document"
        [fileNameToSave]="fileNameToSave"
        [template]="template"
        [allowGuidedSigning]="allowGuidedSigning"
        [documentError]="documentError"
        (outEvent)="eventHandler($event)"
    >
    </pdf-view>
</section>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
